import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendedSolution = ({ solution }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-moderate transition-smooth">
      <div className="relative h-48 overflow-hidden">
        <Image 
          src={solution?.image} 
          alt={solution?.title}
          className="w-full h-full object-cover"
        />
        {solution?.isNew && (
          <span className="absolute top-3 left-3 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium">
            New
          </span>
        )}
        {solution?.discount && (
          <span className="absolute top-3 right-3 bg-error text-error-foreground px-2 py-1 rounded-full text-xs font-medium">
            {solution?.discount}% OFF
          </span>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h4 className="font-semibold text-foreground line-clamp-2">{solution?.title}</h4>
          <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full ml-2 whitespace-nowrap">
            {solution?.category}
          </span>
        </div>
        
        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{solution?.description}</p>
        
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-1">
            <div className="flex">
              {[...Array(5)]?.map((_, i) => (
                <Icon 
                  key={i}
                  name="Star" 
                  size={14} 
                  className={i < solution?.rating ? 'text-accent fill-current' : 'text-muted-foreground/30'}
                />
              ))}
            </div>
            <span className="text-xs text-muted-foreground">({solution?.reviews})</span>
          </div>
          
          {solution?.price && (
            <div className="text-right">
              <span className="text-sm font-semibold text-foreground">
                From UGX {solution?.price?.toLocaleString()}
              </span>
            </div>
          )}
        </div>
        
        <div className="flex space-x-2">
          <Link to={`/service-details?id=${solution?.id}`} className="flex-1">
            <Button variant="outline" size="sm" fullWidth iconName="Info">
              Details
            </Button>
          </Link>
          <Link to={`/rfq-request-form?service=${solution?.id}`} className="flex-1">
            <Button variant="default" size="sm" fullWidth iconName="FileText">
              Request Quote
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecommendedSolution;